import createOrUpdateHiddenField from './createOrUpdateHiddenField';
import { getTrackedAttributesString } from './trackingAttributesGenerator';

const injectFormTrackingAttributes = (form) => {
	if (form) {
		const trackedData = getTrackedAttributesString(new FormData(form));
		createOrUpdateHiddenField(form, 'userSessionData', trackedData);
	}
};

export default injectFormTrackingAttributes;
